import styled from 'styled-components'

export default styled.div`
  font-weight: bold;
  margin-bottom: 10px;
`
